import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

export const SupportingTodoTypes = [
  WintSuperkollAPIModel.TodoType.IncomingInvoice,
  WintSuperkollAPIModel.TodoType.Receipt,
  WintSuperkollAPIModel.TodoType.MissingDocument,
  WintSuperkollAPIModel.TodoType.Support,
  WintSuperkollAPIModel.TodoType.Invoice,
  WintSuperkollAPIModel.TodoType.SalaryDeviationReport,
  WintSuperkollAPIModel.TodoType.AgentSaleMissingInformation,
  WintSuperkollAPIModel.TodoType.SalaryDraft,
  WintSuperkollAPIModel.TodoType.PersonSalaryReport,
  WintSuperkollAPIModel.TodoType.DocumentDraft,
  WintSuperkollAPIModel.TodoType.UnhandledBankPayments,
  WintSuperkollAPIModel.TodoType.PaymentSigningInformation,
  WintSuperkollAPIModel.TodoType.StoppedPayment,
  WintSuperkollAPIModel.TodoType.QualifiedShareDividend,
  WintSuperkollAPIModel.TodoType.PausedPayments,
  WintSuperkollAPIModel.TodoType.ProfileRoutine,
  WintSuperkollAPIModel.TodoType.GenericVouchersSentBack,
  WintSuperkollAPIModel.TodoType.Survey,
  WintSuperkollAPIModel.TodoType.SupplementaryMaterial,
  WintSuperkollAPIModel.TodoType.SalaryDeviationAndTimeLogReport,
  WintSuperkollAPIModel.TodoType.AnnualAccountsForCustomerApproval,
  WintSuperkollAPIModel.TodoType.ReceiptDraft,
  WintSuperkollAPIModel.TodoType.ShareRegister,
  WintSuperkollAPIModel.TodoType.SalaryDeviationReportWithBusinessUnits,
  WintSuperkollAPIModel.TodoType.AgingIncomingInvoice,
  WintSuperkollAPIModel.TodoType.SelfInvoice,
  WintSuperkollAPIModel.TodoType.AuditorReportToUpload,
  WintSuperkollAPIModel.TodoType.AuditorReportToSign,
  WintSuperkollAPIModel.TodoType.AnnualReportSigningSteps,
  WintSuperkollAPIModel.TodoType.AuditorAnnualReportSigningSteps,
  WintSuperkollAPIModel.TodoType.WintSalaryApprovalReport,
  WintSuperkollAPIModel.TodoType.RemovedDocumentDraft,
  WintSuperkollAPIModel.TodoType.UpdateNewBoardMembersData,
  WintSuperkollAPIModel.TodoType.ClassifiedReceiptTodo,
  WintSuperkollAPIModel.TodoType.ExternalCompanyHoldings,
  WintSuperkollAPIModel.TodoType.PreliminaryTaxUpdate,
  WintSuperkollAPIModel.TodoType.BankPortalSigning,
  WintSuperkollAPIModel.TodoType.RevenueReportNotSubmitted,
];

export const RouteTodoSelectionKey = "details";
export const TodosPerPage = 100;
export const TodoLoadIntervalMs = 600000; //10 mins
export const TopCardId = "topCard";
